import { Tooltip } from '@odo/shared-ui';
import type { UserPractice } from '../../../services/users';
import { PracticeChip } from './PracticeChip';

const ODO_STAFF_DOMAIN = '@ondemandorthodontist.com';
const MAX_VISIBLE_CHIPS = 2;

interface PracticesCellProps {
    email: string;
    practices: UserPractice[];
}

// ODO staff (@ondemandorthodontist.com accounts with no practice links) read
// as "ODO staff" rather than an empty dash - it's expected, not missing data.
export function PracticesCell({ email, practices }: PracticesCellProps) {
    const isOdoStaff = practices.length === 0 && email.toLowerCase().endsWith(ODO_STAFF_DOMAIN);
    if (isOdoStaff) {
        return <span className="text-[13px] text-gray-400">ODO staff</span>;
    }
    if (practices.length === 0) {
        return <span className="text-sm text-gray-300">-</span>;
    }

    const shown = practices.slice(0, MAX_VISIBLE_CHIPS);
    const rest = practices.slice(MAX_VISIBLE_CHIPS);

    return (
        <div className="flex items-center gap-1.5 min-w-0">
            {shown.map((practice) => (
                <PracticeChip key={practice.id} id={practice.id} name={practice.name} />
            ))}
            {rest.length > 0 && (
                <Tooltip content={rest.map((practice) => practice.name ?? practice.id).join(', ')}>
                    <span className="inline-flex items-center h-6 px-2 rounded-full bg-gray-100 text-[11px] font-bold text-gray-600 cursor-default">
                        +{rest.length}
                    </span>
                </Tooltip>
            )}
        </div>
    );
}
